import * as defaultImport from "hash-it";
export * from "hash-it";
export default defaultImport.default;
